/**
 * @generated SignedSource<<27bc54a05a54e0b2f9f387e6d552a0ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appAzureActiveDirectory_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly AADEnabled: boolean | null;
    readonly oneloginEnabled: boolean | null;
    readonly oktaEnabled: boolean | null;
    readonly scimUsernamePassword: string | null;
    readonly AADTenant: string | null;
    readonly AADClientId: string | null;
    readonly AADClientSecret: string | null;
  } | null;
  readonly " $fragmentType": "appAzureActiveDirectory_viewer";
};
export type appAzureActiveDirectory_viewer$key = {
  readonly " $data"?: appAzureActiveDirectory_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"appAzureActiveDirectory_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appAzureActiveDirectory_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scimUsernamePassword",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADTenant",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADClientId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADClientSecret",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "63c7529358c7a22c5cae0bcff0afeeee";

export default node;
